import type { GeoJSON, LayerGroup, Map } from "leaflet"
export type LayerConstructor = (
	layerName: string,
	zIndex: number,
	map: Map
) => LayerGroup | GeoJSON | undefined

export const defaultLayerConstructor: LayerConstructor = (layerName, zIndex, map) => {
	if (map === undefined) {
		return
	}
	const layerPaneName = `${layerName}Pane`
	map.createPane(layerPaneName)
	map.getPane(layerPaneName)!.style.zIndex = `${zIndex}`
	const newLayerGroup = L.layerGroup([], {
		pane: layerPaneName,
	})
	newLayerGroup.addTo(map)
	return newLayerGroup
}
